import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
export function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <footer className="w-full bg-gray-900 border-t border-gray-800 py-6 mt-auto" data-id="element-130">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-131">
          <div className="flex flex-col items-center gap-6 mb-6" data-id="element-132">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nsoAdMCr2MakXFCqq5bSP/gb_signature.png" alt="Signature" className="w-full max-w-[150px]" data-id="element-133" />
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-134">
            <div className="text-gray-400 text-sm" data-id="element-135">
              © 2024 TrueMarketer. Todos los derechos reservados.
            </div>
            <div className="flex items-center gap-6 text-sm" data-id="element-136">
              <button onClick={() => setIsModalOpen(true)} className="text-gray-400 hover:text-white transition-colors" data-id="element-137">
                Política de Privacidad
              </button>
              <a href="mailto:support@truemarketer.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-138">
                support@truemarketer.com
              </a>
            </div>
          </div>
        </div>
      </footer>
      <PrivacyPolicyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-139" />
    </>;
}